var xtable = function(){};

xtable.prototype = {
	init:function(el){
		var me = this;
		el.data('xgrid', me);
		
        me.el = el;
		el[0].xgrid = me; // kad turėti xgrid objektą prie elemento
		el.addClass('xgrid_initialized');

		me.dataset = el.find('table').data('dataset');
		
		me.render(el);
		
		me.ajax = Object.create(me._ajax).init(me);
		me.listeners = Object.create(me._listeners).init(me);
		
		return me;
	},
	render:function(el){
		var me = this;
		
		me.top_filters = el.find('.xgrid_action-bar__left');

		me.table = el.find('table');
		
		me.body = el.find('tbody');
		me.head = el.find('thead');
		me.summary = el.find('tfoot');
		me.footer = el.find('.footer');		

		
		me.filters = me.head.find('tr.filters');

		me.headers = me.head.find('tr.headers');
		
	},
	getCheckedValues: function (array = false, separator = ',') {
		var checked = [],
			dataAttr = array ? 'json' : 'pk';

		this.body
			.find('.xgrid_row-checkbox input:checked')
			.each(function (_, chk) {
				checked.push($(chk).closest('tr').data('pk'));
			});

		if (array) return checked;

		return checked.join(separator);
	},
	_listeners:{
		init: function (me) {
			this.me = me;
			this.checkboxes();
			this.filters();
			this.top_filters();
			this.sort();
		},
		checkboxes: function () {
			var me = this.me;

            me.headers.find('.xgrid_row-checkbox').off('click').on('click', function (e) {
				e.stopPropagation();

                var headerCheckBox = $(e.currentTarget).find('input'),
                    checkboxes = me.body.find('.xgrid_row-checkbox input');
					
				checkboxes.prop('checked', headerCheckBox.prop('checked'));
			});
			
			// Jeigu atzymim viena checkboxa - naikinam headeriuose checkboxo checked state - false
			// Jeigu pazymim visus body checkboxus - uzdedam headeriuose checkboxo checked state - true
			me.body.find('.xgrid_row-checkbox input').on('change', function(e) {
				let headerCheckBox = me.headers.find('.xgrid_row-checkbox input');	
				
				if(me.body.find('.xgrid_row-checkbox input:checked').length == me.body.find('.xgrid_row-checkbox').length) {
					headerCheckBox.prop('checked', true);
				} else {
					headerCheckBox.prop('checked', false);
				}
			});

			// Bindinam clicka ant checkboxo isores
			me.body.find('.xgrid_row-checkbox').closest('td').css({'cursor': 'pointer'}).on('click', function(e) {
				$(e.target).find('input[type=checkbox]').click();
			});
		},
		filters:function(){
			var me = this.me,
				ajax = me.ajax,
				filters = me.filters,
				inputs = me.filters.find('input'),
				selects = me.filters.find('select'),
				values = {};
		
			inputs.on('keyup keypress blur change apply.daterangepicker', e => {
				let val = e.currentTarget.value;
				if (val === ''){
					$(e.currentTarget).closest('.form-group').removeClass('has-value'); 
				} else {
					$(e.currentTarget).closest('.form-group').addClass('has-value'); 
				}
			});

			inputs.closest('.input-group').find('.input-filter-icon').click(e=>{			
				$(e.currentTarget).closest('.input-group').find('.form-control').val('').closest('.form-group').removeClass('has-value');
				values[$(e.currentTarget).closest('.input-group').find('.form-control').attr('name')] = '';
				ajax.filter(values);
			});
			
			$.each(inputs, function(e){
				if($(this).data('type') === 'xdaterange') {
					$(this).on('apply.daterangepicker', function(e) {
						values[$(this).attr('name')] = $(this).val();
						ajax.filter(values);
					});
					return;
				}

				$(this).keydown(function(e){
					if (e.which !== 13){
						return;
					}
					values[$(this).attr('name')] = $(this).val();
					ajax.filter(values);
				});
			});
		},
		top_filters:function(){
			var me = this.me,
				ajax = me.ajax,
				top_filters = me.top_filters;
				a = top_filters.find('a');
			
			a.click(e=>{
				me.top_filter_values = {};
				a.removeClass('active');
				$(e.currentTarget).addClass('active');
				me.top_filter_values[$(e.currentTarget).next('input').data('filter')] = $(e.currentTarget).next('input').data('id');
				ajax.top_filter(me.top_filter_values);
			});
		},
		sort:function(){
			var me = this.me,
				ajax = me.ajax;

			$('.checkboxSort').css({'cursor': 'pointer'});

			me.headers.on('click', 'th', function(e) {
				let target = $(e.target),
					sort = target.data('sort'),
					sortClass = target.attr('class'),
					dir = 'asc';

				// Jeigu checkboxas - disablinam sortinima
				if(target.is('.checkboxSort')) {
					target.find('.xgrid_row-checkbox input').click();
					return;
				} else if (target.data('sortable') === false) {
					// Atvejis tokiems columnam kaip veiksmai ir t.t.t.
					return;
				}

				// Trinam lauk uzsilikusius arrowus
				me.headers.find('th').not(target).removeClass('xgrid2-sort-asc xgrid2-sort-desc');

				if(sortClass === 'xgrid2-sort-asc') {
					// If ascending - make descending
					target.removeClass('xgrid2-sort-asc').addClass('xgrid2-sort-desc');
					dir = 'desc';
				} else if (sortClass === 'xgrid2-sort-desc') {
					// If descending - restore
					target.removeClass('xgrid2-sort-desc');
					dir = 'restore';
				} else {
					// Make ascending
					target.addClass('xgrid2-sort-asc');
					dir = 'asc';
				}

				me.ajax.sort(sort, dir);
			});
		}
	},
	_ajax:{
		init: function(me){
			this.me = me;
			var ajax = this;
			
			ajax._data = {
				'_dataset': me.dataset
			};
			
			ajax.config = {
                url: '/xtable/body',
                type: 'POST',
                data: $('.xgrid').data('cache') || {},
                success: function (response) {
                    me.body.empty();
					me.body.append(response.body);

					// Jeigu yra summary [aggregate]
					if(response.summary && response.summary.length > 0 && me.summary.length > 0) {
						me.summary.empty();
						me.summary.append(response.summary);	
					}

					// Jeigu yra pagingas
					if(response.footer && response.footer.length > 0 && me.footer.length > 0) {
						me.footer.empty();
						me.footer.append(response.footer);
					}
                }
            };
			
            return ajax;
		},
		filter: function(data){
			var me = this,
				config = this.config;
			
			
			
			$.extend(this.config.data, data, this._data);
			this.config.data._type = 'filter';
			
			
			this.loading = true;

			$.ajax(config);
			
		},
		sort: function(col, dir) {
			var ajax = this,
				config = ajax.config;
			
			// Sort config for ajax
			let data = {
				_type: 'sort',
				_orderBy: col,
				_orderDir: dir,
			};
			
				
			$.extend(config.data, data, this._data);

			$.ajax(config);
		},
		top_filter: function(data){
			var ajax = this,
				config = ajax.config,
				data = {
				_type: 'top_filter',
				_values: data,
			};

			$.extend(config.data, data, this._data);
			$.ajax(config)
		}
	}
};

/* Multi filtrai gridui */
var xfilter = function(){};
xfilter.prototype = {
    init: function(el) {
        let me = this;
		me.el = $(el);
		
        me.render();
        me.listeners();
		//me.getCheckedValuesForText();
		//me.getCheckedValues();
    },
    render: function(el) {
		let me = this;

        me.filter = $('.multiFilter');
		me.filter.css('width', '240px');
		
		me.key = me.filter.find('.data-area .checkbox').find('input').attr('name');

		me.searchBox = me.filter.find('.searchBox');
		
		me.submitBtn = $('#submitBtn');

		me.xtable = $(me.el.closest('.xgrid2')).xtable();
		
		me.filterName = me.el.find('.filterText').text();

        me.sortAsc = $('#asc');
        me.sortDesc = $('#desc');
    },
    listeners: function(el) {
        let me = this;
        me.show();
        me.click();
        me.filterCheckboxes();
        me.onCheckBoxClick();
    },
    show: function(el) {
        let me = this;
        
        me.cached = false;
        
        me.el.on('click', function(e) {
            e.stopPropagation();
            if (!me.cached) 
                //me.getData(null);
            me.filter.addClass('opened').show();
            me.searchBox.focus();
        });
    },
    click: function(e) {
        let me = this;

        me.filter.on('click', function(e) {
			e.stopPropagation();
		});
		
		// Disablinam bubblinima inputu
		me.filter.find('input').on('click', function(e) {
			e.stopPropagation();
		});

		me.el.on('click', function(e) {
			$(document).one('click', function() {
				if(me.filter.hasClass('opened')) {
					me.filter.removeClass('opened').hide();
				}
			});
		});
       
    },
    getData: function(data) {
        let me = this;

        xcrud.load(
            '/php/test/arturas/test.php',
            data,
            content => {
                $('.data-area').html(content);
            }
        )

        me.cached = true;
    },
    filterCheckboxes: function(e) {
		let me = this;

        me.searchBox.on('keyup', function(e) {
			let query = this.value.toLowerCase();

            me.filter.find('.data-area .checkbox').each(function(i, el) {
				if($(el).closest('.checkbox').find('.checkbox-text').text().toLowerCase().indexOf(query) != -1) {
					$(el).find('label').toggleClass('d-none', false);
					$(el).find('.counters').toggleClass('d-none', false);
				} else {
					$(el).find('label').toggleClass('d-none', true);
					$(el).find('.counters').toggleClass('d-none', true);
				}
            });
        });

        me.sortAsc.on('click', function(e) {
			let arr = me.filter.find('.data-area .counters').sort(function(a, b) {
				return $(a).text() - $(b).text()
			});

			let sorted = arr.map((key, item) => {
				return item.closest('.checkbox');
			});
			
			me.filter.find('.data-area').html(sorted);
			me.click();
        	me.onCheckBoxClick();
        });

        me.sortDesc.on('click', function(e) {
            let arr = me.filter.find('.data-area .counters').sort(function(a, b) {
				return $(b).text() - $(a).text()
			});

			let sorted = arr.map((key, item) => {
				return item.closest('.checkbox');
			});
			
			me.filter.find('.data-area').html(sorted);
			me.click();
			me.onCheckBoxClick();
        });
    },
    onCheckBoxClick: function(e) {
		let me = this,
			key = me.key;

        me.filter.find('.data-area input[type="checkbox"]').on('click', function(e) {
			e.stopPropagation();
            if(me.getCheckedValues().length > 0) {
				me.el.find('span').text(me.getCheckedValuesForText());
				if(me.el.find('span').text().length > 50) {
					let shortText = jQuery.trim(me.el.find('span').text()).substring(0, 50)
						.split(",").slice(0, -1).join(",") + "...";

					me.el.find('span').text(shortText);
				}
				
				me.xtable.ajax.filter({[key] : me.getCheckedValues()});
           	} else {
				me.xtable.ajax.filter({[key] : me.getCheckedValues()});
				me.el.find('span').text(me.filterName);
            }
        });
    },
    getCheckedValuesForText: function(e) {
        let me = this, 
			values = '';

		values = me.filter.find('.data-area input[type="checkbox"]:checked').map(function(i,el){
			return $(this).closest('.checkbox').find('.checkbox-text').text();
		}).get().join(',');
		
        return values;
	},
	getCheckedValues: function(e) {
        let me = this, 
			values = '';
					
		values = me.filter.find('.data-area input[type="checkbox"]:checked').map(function(i,el){
			return $(el).val();
		}).get().join(',');

        return values;
    }
};

(function($) {
	$.fn.xfilter = function(options) {
		var $xfilter = this,
			xfilterEl;
		
		if ($xfilter.length === 0) {
			throw new Error(
				'ERROR'
			);
		}

		if ($xfilter[0].xfilter) {
			return $xfilter[0].xfilter;
		}

		xfilterEl = new xfilter().init($xfilter);
		return xfilterEl;
	};
})(jQuery);

(function($) {
	$.fn.xtable = function() {
		var table = this,
			xtable = table[0];
		
		if (xtable.xgrid){
			return xtable.xgrid;
		}

		return new xtable().init(table);
	};
})(jQuery);